"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function trx(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M16.449 7.43475L5.625 5.44275L11.3213 19.7767L19.2585 10.1062L16.449 7.43475ZM16.275 8.31225L17.931 9.8865L13.4025 10.7062L16.275 8.31225ZM12.4185 10.542L7.6455 6.5835L15.447 8.019L12.4185 10.542ZM12.0788 11.2425L11.3003 17.6775L7.104 7.11525L12.0788 11.2417V11.2425ZM12.7988 11.5837L17.814 10.6762L12.0615 17.6835L12.7988 11.5837Z", fill: color }),
        React.createElement("path", { d: "M16.0072 6.82501L5.18323 4.83301L10.8795 19.167L18.8167 9.49651L16.0072 6.82501ZM15.8332 7.70251L17.4892 9.27676L12.9607 10.0965L15.8332 7.70251ZM11.9767 9.93226L7.20373 5.97376L15.0052 7.40926L11.9767 9.93226ZM11.637 10.6328L10.8585 17.0678L6.66223 6.50551L11.637 10.632V10.6328ZM12.357 10.974L17.3722 10.0665L11.6197 17.0738L12.357 10.974Z", fill: color }));
}
exports["default"] = trx;
//# sourceMappingURL=trx.js.map